/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

/**
 * This component is used to share values between multiple components in payment-widget
 * it separates the logic of using global variable, so it can be changed in the future
 * if there is a need to
 */

var _ = require('underscore');
var $ = require('jquery');

const { RegistrationOption } = require('../../utils/data/enums');

function saveConfig(config) {
    _.extend(glob, config);
}

function getTrimmedKey(key) {
    if (key && typeof key === 'string') return key.trim();
    else return '';
}

function storeData(key, data) {
    key = getTrimmedKey(key);
    if (key) glob[key] = data;
}

function getStoredData(key) {
    key = getTrimmedKey(key);
    if (key && Object.hasOwnProperty.call(glob, key)) return glob[key];
}

function removeStoredData(key) {
    key = getTrimmedKey(key);
    if (key && Object.hasOwnProperty.call(glob, key)) delete glob[key];
}

function getAllAccounts() {
    return glob.accounts;
}

function getPresetAccount() {
    return glob.presetAccount;
}

function getSelectedNetwork() {
    return glob.selectedNetwork;
}
function resetSelectedNetwork() {
    return setSelectedNetwork(null);
}

function getListHandler() {
    return glob.listHandler;
}

function addQueryString(url, key, val) {
    var sep = '?';
    if (!url) {
        return;
    }
    if (url.lastIndexOf('?') !== -1) {
        sep = '&';
    }
    return url + sep + encodeURIComponent(key) + '=' + encodeURIComponent(val);
}

function getListUrl() {
    return addQueryString(glob.listUrl, 'packageVersion', glob.packageVersion);
}

function getOriginalListUrl() {
    return glob.listUrl;
}

function getSelectedNetworkCode() {
    return glob.selectedNetwork && glob.selectedNetwork.networkCode ? glob.selectedNetwork.networkCode : null;
}

function setSelectedNetwork(network) {
    return (glob.selectedNetwork = network);
}

function getSeparatedOperations(network) {
    const code = network.code;

    return glob.operations && glob.operations[code] ? glob.operations[code] : null;
}

function getCombinedOperationsForUpdate(network) {
    const registration = network['registration'];
    const recurrence = network['recurrence'];

    return {
        autoRegistration: registration !== RegistrationOption.NONE,
        allowRecurrence: recurrence !== RegistrationOption.NONE,
    };
}

function getCombinedOperations(network, isChecked = false) {
    const registration = network['registration'];
    const recurrence = network['recurrence'];

    let autoRegistration = false;
    let allowRecurrence = false;

    // needed for PCX-2661 klarna exception
    if (registration === RegistrationOption.NONE) {
        if (recurrence === RegistrationOption.FORCED || recurrence === RegistrationOption.FORCED_DISPLAYED) {
            allowRecurrence = true;
        }
        if (recurrence === RegistrationOption.OPTIONAL || recurrence === RegistrationOption.OPTIONAL_PRESELECTED) {
            if (isChecked) {
                allowRecurrence = true;
            }
        }
    }
    if (registration === RegistrationOption.FORCED || registration === RegistrationOption.FORCED_DISPLAYED) {
        autoRegistration = true;
        if (recurrence === RegistrationOption.FORCED || recurrence === RegistrationOption.FORCED_DISPLAYED) {
            allowRecurrence = true;
        }
    }
    if (registration === RegistrationOption.OPTIONAL || registration === RegistrationOption.OPTIONAL_PRESELECTED) {
        if (isChecked) {
            autoRegistration = true;
        }
        if (recurrence === RegistrationOption.OPTIONAL || recurrence === RegistrationOption.OPTIONAL_PRESELECTED) {
            allowRecurrence = autoRegistration;
        }
    }

    return {
        autoRegistration,
        allowRecurrence,
    };
}

function getOperations(network) {
    if (!isRegistrationOptionsCombined()) {
        // get operations from separated operations
        return getSeparatedOperations(network);
    }

    if (isUpdate()) {
        // returns combined operations for update flow
        return getCombinedOperationsForUpdate(network);
    }

    const networkCode = network['code'];
    const isChecked = $(`#${networkCode}-registration`).prop('checked');

    // returns combined operations for charge, preset, normal flow
    return getCombinedOperations(network, isChecked);
}

function setSeparatedOperation(networkCode, operationKey, operationValue) {
    if (!glob.operations[networkCode]) {
        glob.operations[networkCode] = {};
    }

    return (glob.operations[networkCode][operationKey] = operationValue);
}

function getAllNetworks() {
    return glob.networks;
}

function setAllNetworks(networks) {
    return (glob.networks = networks);
}

function getAnimationSpeed() {
    return glob.animationSpeed;
}

function isSmartSwitch() {
    return glob.smartSwitch;
}

function isUpdate() {
    return glob.isUpdate;
}

function isPayout() {
    return glob.isPayout;
}

function showDelete() {
    return glob.showDelete;
}

function isLiveValidation() {
    return glob.liveValidation;
}

function getSubmitButton() {
    return glob.submitButton;
}

function setSubmitButton(button) {
    return (glob.submitButton = button);
}

function getListContainer() {
    return glob.listContainer;
}

function getIsFullPageLoading() {
    return glob.fullPageLoading;
}

function getOpgOrigin() {
    return glob.opg_origin;
}

function setOpgOrigin(input) {
    return (glob.opg_origin = input);
}

function setValidationTimer(timer) {
    return (glob.validationTimer = timer);
}

function getValidationTimer() {
    return glob.validationTimer;
}

function getValidationDelay() {
    return glob.validationDelay;
}

function getPageTranslation() {
    return glob.pageTranslation;
}

function setPageTranslation(translation) {
    return (glob.pageTranslation = translation);
}

function getSuppressIFrameDefault() {
    return glob.suppressIFrameDefault;
}

function getMessageListener() {
    return glob.messageListener;
}

function setMessageListener(input) {
    return (glob.messageListener = input);
}

function isEventBound() {
    return glob.isEventBound;
}

function setEventBound(boolValue) {
    return (glob.isEventBound = boolValue);
}

function setSubmitButtonBound() {
    glob.boundSubmitButton.push(glob.payButton);
}
function getSubmitButtonBound() {
    return glob.boundSubmitButton;
}

function getIsSingleMethod() {
    return glob.isSingleMethod;
}

function setIsSingleMethod(boolValue) {
    return (glob.isSingleMethod = boolValue);
}

function clientSideRemoveNetwork(code) {
    glob.networks = _.omit(glob.networks, function (value, key) {
        return key === code;
    });
}

function clientSideRemoveAccount(code) {
    glob.accounts = _.toArray(
        _.omit(glob.accounts, function (value) {
            return value.label.toLowerCase() === code.toLowerCase();
        })
    );
}

function setProperties(listHandlerData) {
    glob.listResponse = JSON.parse(JSON.stringify(listHandlerData));
    glob.animationSpeed = glob.useAnimations ? 200 : null;
    glob.networks = listHandlerData.networks && listHandlerData.networks.applicable ? listHandlerData.networks.applicable : [];
    glob.accounts = listHandlerData.accounts ? listHandlerData.accounts : [];
    glob.isUpdate = listHandlerData.operationType === 'UPDATE';
    glob.showDelete = (glob.isUpdate && listHandlerData.allowDelete !== false) || (!glob.isUpdate && listHandlerData.allowDelete === true);
    glob.operations = {};
    glob.presetAccount = listHandlerData.presetAccount ? listHandlerData.presetAccount : null;
    glob.isPayout = listHandlerData.operationType === 'PAYOUT';
    glob.integrationType = listHandlerData.integrationType;
    glob.hostedVersion = listHandlerData.style.hostedVersion;
    glob.language = listHandlerData.style.language;
}

function getPayButton() {
    return glob.payButton;
}

function getPayButtonContainer() {
    return glob.payButtonContainer;
}

function hasAbortFunction() {
    return typeof glob.abortFunction === 'function';
}

function hasProceedFunction() {
    return typeof glob.proceedFunction === 'function';
}

function abortFunction(boundData) {
    return hasAbortFunction() ? glob.abortFunction(boundData) : undefined;
}

function proceedFunction(boundData) {
    return hasProceedFunction() ? glob.proceedFunction(boundData) : undefined;
}

function setIsCancelEventFired(isCanceled = false) {
    glob.isCancelEventAlreadyFired = isCanceled;
}

function isAlreadyNotifiedAboutCancelEvent() {
    return glob.isCancelEventAlreadyFired;
}

function isProviderRedirectEnabled() {
    return glob.providerRedirectInNewWindow === true;
}

function isCardView() {
    return glob.cardView || isMobile();
}

function isMobile() {
    return screen.width <= 736;
}

function getSpecialButtonsClass() {
    var buttonsContainer = getPayButtonContainer();

    return buttonsContainer + 'Group';
}

function removeSpecialButtons() {
    $('.' + getSpecialButtonsClass()).remove();
}

function getIFrameScale() {
    var iFrameScale = Number(glob.iFrameScaleFunction());
    if (isNaN(iFrameScale)) {
        return 1;
    }
    if (iFrameScale <= 0) {
        return 1;
    }
    return iFrameScale;
}

function getWidgetCssUrl() {
    return glob.widgetCssUrl;
}

function getCssUrl() {
    return glob.cssUrl;
}

function getOperationType() {
    return (glob.listResponse && glob.listResponse.operationType && glob.listResponse.operationType.toLowerCase()) || 'charge';
}

function isRegisteredAccount(formId) {
    return formId.indexOf('registered') === 0;
}

function resetRemainingProcess() {
    glob.remainingProcess = 0;
}

function increaseRemainingProcess() {
    glob.remainingProcess += 1;
}

function decreaseRemainingProcess() {
    if (glob.remainingProcess <= 1) {
        resetRemainingProcess();
        return;
    }
    glob.remainingProcess -= 1;
}

function isNoRemainingProcess() {
    if (glob.remainingProcess <= 0) {
        resetRemainingProcess();
        return true;
    }
    return false;
}

function getRemainingProcess() {
    return glob.remainingProcess;
}

function preloadIsNeeded() {
    return glob.preloadInProgress === true;
}

function noPreloadNeeded() {
    return !preloadIsNeeded();
}

function aPreloadInProgress() {
    glob.preloadInProgress = true;
}

function resetPreloadInProgress() {
    glob.preloadInProgress = false;
}

function getMainContainer() {
    return glob.mainContainer;
}

function getTemplateName() {
    return glob.templateName;
}

function getBaseUrl() {
    return glob.baseUrl;
}

function getListDetails() {
    return glob.listDetails;
}

function getIntegrationType() {
    return glob.integrationType;
}

function setTranslationObject(code, value) {
    glob.networkTranslation[code] = value;
}

function getTranslationObject(networkCode) {
    return glob.networkTranslation[networkCode];
}

function getHostedVersion() {
    return glob.hostedVersion;
}

function getLanguage() {
    return glob.language;
}

function isSummaryPage() {
    return !!glob.summaryPage;
}

function getLastValidationResponseId() {
    return glob.lastValidationResponseId || 0;
}

function getLastValidationRequestId() {
    return glob.lastValidationRequestId || 0;
}

function setLastValidationResponseId(id) {
    glob.lastValidationResponseId = id;
}

function setLastValidationRequestId(id) {
    glob.lastValidationRequestId = id;
}

function incrementAndGetLastValidationResponseId() {
    var requestId = getLastValidationRequestId();
    var newRequestId = requestId + 1;
    setLastValidationRequestId(newRequestId);

    return newRequestId;
}

function enableSpecialButton() {
    const network = getSelectedNetwork();
    $(`#fn${network?.networkCode}-submitButton`).prop('disabled', false);
}

function isRegistrationOptionsCombined() {
    return !!glob.combineRegistrationOptions;
}

module.exports = {
    saveConfig,
    storeData,
    getStoredData,
    removeStoredData,
    getSelectedNetwork,
    getSelectedNetworkCode,
    setSelectedNetwork,
    getOperations,
    getAllNetworks,
    setAllNetworks,
    getAllAccounts,
    getPresetAccount,
    getAnimationSpeed,
    isSmartSwitch,
    isUpdate,
    isPayout,
    showDelete,
    isLiveValidation,
    getListContainer,
    getSubmitButton,
    setSubmitButton,
    getOpgOrigin,
    setOpgOrigin,
    setValidationTimer,
    getValidationTimer,
    getValidationDelay,
    getPageTranslation,
    setPageTranslation,
    getSuppressIFrameDefault,
    getMessageListener,
    setMessageListener,
    getListHandler,
    getListUrl,
    getOriginalListUrl,
    setProperties,
    isEventBound,
    setEventBound,
    getPayButton,
    isCardView,
    isMobile,
    proceedFunction,
    hasProceedFunction,
    abortFunction,
    hasAbortFunction,
    getPayButtonContainer,
    getSpecialButtonsClass,
    clientSideRemoveNetwork,
    clientSideRemoveAccount,
    setSubmitButtonBound,
    getSubmitButtonBound,
    getIFrameScale,
    getCssUrl,
    getWidgetCssUrl,
    resetSelectedNetwork,
    removeSpecialButtons,
    isRegisteredAccount,
    getOperationType,
    resetRemainingProcess,
    increaseRemainingProcess,
    decreaseRemainingProcess,
    isNoRemainingProcess,
    getRemainingProcess,
    noPreloadNeeded,
    aPreloadInProgress,
    resetPreloadInProgress,
    getIsFullPageLoading,
    getMainContainer,
    getIsSingleMethod,
    setIsSingleMethod,
    getTemplateName,
    getBaseUrl,
    getListDetails,
    getIntegrationType,
    setTranslationObject,
    getTranslationObject,
    getHostedVersion,
    getLanguage,
    isSummaryPage,
    getLastValidationResponseId,
    setLastValidationResponseId,
    incrementAndGetLastValidationResponseId,
    enableSpecialButton,
    isRegistrationOptionsCombined,
    setSeparatedOperation,
    getSeparatedOperations,
    setIsCancelEventFired,
    isAlreadyNotifiedAboutCancelEvent,
    isProviderRedirectEnabled,
    getCombinedOperationsForUpdate,
    getCombinedOperations,
};
